import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, GiftIcon, ShieldCheckIcon } from 'lucide-react';
export function ProductDisplaySection() {
  return <section id="producto" className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#0f172a',
    borderColor: '#334155'
  }} data-id="element-265">
      <div className="max-w-4xl mx-auto" data-id="element-266">
        <div id="ebook-main" className="text-center mb-12" data-id="element-267">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight mb-6" style={{
          color: '#f1f5f9'
        }} data-id="element-268">
            ¡SÍ! Quiero el Sistema LPM™ Ahora
          </h2>
          <p className="text-xl md:text-2xl" style={{
          color: '#94a3b8'
        }} data-id="element-269">
            Asegura tu acceso a la guía definitiva para generar{' '}
            <span style={{
            color: '#f59e0b'
          }} data-id="element-270">
              6 millones/mes
            </span>{' '}
            con Landing Pages e IA.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 mb-12" data-id="element-271">
          {/* Product Image */}
          <div className="w-full md:w-1/2 flex justify-center" data-id="element-272">
            <div className="relative" data-id="element-273">
              <div className="absolute inset-0 blur-2xl opacity-20 rounded-full" style={{
              backgroundColor: '#f59e0b'
            }} data-id="element-274"></div>
              <img src="https://cdn.magicpatterns.com/uploads/k6YHtqymmj3dMRAdQeZa3r/ChatGPT_Image_4_mar_2026,_04_35_52_p.m..png" alt="Producto Sistema LPM en Tablet" className="relative z-10 w-full max-w-sm transform hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width="384" height="384" data-id="element-275" />
            </div>
          </div>

          {/* Product Details */}
          <div className="w-full md:w-1/2" data-id="element-276">
            <p className="text-lg font-bold mb-6 uppercase tracking-wider" style={{
            color: '#f59e0b'
          }} data-id="element-277">
              Lo que obtienes al instante:
            </p>

            <div className="space-y-4 mb-8" data-id="element-278">
              <div className="flex items-start gap-3" data-id="element-279">
                <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
                color: '#f59e0b'
              }} data-id="element-280" />
                <p className="text-lg" style={{
                color: '#f1f5f9'
              }} data-id="element-281">
                  <strong data-id="element-282">Guía Maestra LPM™ (PDF):</strong> El paso a paso de 0
                  a 100, sin relleno.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-283">
                <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
                color: '#f59e0b'
              }} data-id="element-284" />
                <p className="text-lg" style={{
                color: '#f1f5f9'
              }} data-id="element-285">
                  <strong data-id="element-286">Librería Élite de Prompts:</strong> Copia y pega para
                  que la IA escriba tus textos de venta.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-287">
                <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
                color: '#f59e0b'
              }} data-id="element-288" />
                <p className="text-lg" style={{
                color: '#f1f5f9'
              }} data-id="element-289">
                  <strong data-id="element-290">Protocolo de Construcción 60-Minutos:</strong> Crea
                  páginas de $500.000 en tiempo récord.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-291">
                <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
                color: '#f59e0b'
              }} data-id="element-292" />
                <p className="text-lg" style={{
                color: '#f1f5f9'
              }} data-id="element-293">
                  <strong data-id="element-294">Scripts de Prospección Colombia:</strong> Los mensajes
                  exactos para cerrar clientes.
                </p>
              </div>
            </div>

            <div id="bonuses-section" className="p-6 rounded-lg border mb-8" style={{
            backgroundColor: '#1e293b',
            borderColor: '#f59e0b'
          }} data-id="element-295">
              <div className="flex items-start gap-3 mb-3" data-id="element-296">
                <GiftIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
                color: '#f59e0b'
              }} data-id="element-297" />
                <p className="text-lg" style={{
                color: '#f1f5f9'
              }} data-id="element-298">
                  <strong data-id="element-299">BONO:</strong> El Mapa de Éxito de 30 Días.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-300">
                <GiftIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
                color: '#f59e0b'
              }} data-id="element-301" />
                <p className="text-lg" style={{
                color: '#f1f5f9'
              }} data-id="element-302">
                  <strong data-id="element-303">BONO:</strong> Plantilla Profesional de Propuesta.
                </p>
              </div>
            </div>

            <div id="price-section" className="text-center md:text-left mb-8" data-id="element-304">
              <p className="text-lg line-through mb-1" style={{
              color: '#94a3b8'
            }} data-id="element-305">
                Valor Total: $195.000 COP
              </p>
              <p className="text-4xl font-bold mb-2" style={{
              color: '#f1f5f9'
            }} data-id="element-306">
                Solo por hoy:{' '}
                <span style={{
                color: '#f59e0b'
              }} data-id="element-307">
                  $49.999
                </span>
              </p>
              <p className="text-sm" style={{
              color: '#94a3b8'
            }} data-id="element-308">
                (Pago único - Descarga inmediata)
              </p>
            </div>

            <CTAButton text="DESCARGAR GUÍA Y BONOS AHORA" subtitle="Acceso inmediato al sistema completo" redirectToCheckout={true} data-id="element-309" />

            <div className="flex items-center justify-center md:justify-start gap-2 mt-6" data-id="element-310">
              <ShieldCheckIcon className="h-5 w-5" style={{
              color: '#f59e0b'
            }} data-id="element-311" />
              <p className="text-sm" style={{
              color: '#94a3b8'
            }} data-id="element-312">
                Garantía total de devolución de dinero de 30 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}